import Swal from "sweetalert2";
import '../Dashboard/Mainstyle.css';
import './Header.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts//remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Logo from "./Logo";
import Searchbar from "./Searchbar";
import Nav from "./Nav";
import { useEffect, useState } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Modal from 'react-modal';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { getApi, postApi } from "../../components/Admin Master/Area Control/Zonemaster/ServicesApi"; // ✅ ADD

function Header() {
   
const [walletBalance, setWalletBalance] = useState(0);
const [walletAmount, setWalletAmount] = useState(0);

    
const getWalletLedger = async (CustomerCode) => {
    if (!CustomerCode) return;

    try {
        const response = await postApi(`/Master/getWalletLedgerDocketWise?Customer_Code=${CustomerCode}`);
        if (response.status === 1) {
            setWalletBalance(response.Summary.CurrentBalance);
            setWalletAmount(response.Summary.TotalDebit);
        } else {
            setWalletBalance(0);
            setWalletAmount(0);
        }
    } catch (error) {
        console.error(error);
        setWalletBalance(0);
        setWalletAmount(0);
    }
};
useEffect(() => {
    getWalletLedger(JSON.parse(localStorage.getItem('Login'))?.Customer_Code);
}, []);



    return (
        <header id="header" className="header fixed-top d-flex align-items-center justify-content-between ">
            <Logo />
            {JSON.parse(localStorage.getItem('Login'))?.UserType=="User" && <div className="credit-box" style={{ marginLeft: "10px", display: "flex", gap: "5px", justifyContent: "center", whiteSpace: "nowrap", fontSize: "12px", fontWeight: "bold" }}>
                <div style={{ display: "flex", justifyContent: "center", flexDirection:"column", alignItems: "center",color:"green", padding: "5px", borderRadius: "5px", }}> <span>BALANCE :</span> <span>{walletBalance} </span></div>
                <div style={{ display: "flex", justifyContent: "center", flexDirection:"column", alignItems: "center",color:"red", padding: "5px", borderRadius: "5px", }}> <span>TOTALDEBIT : </span> <span>{walletAmount}</span></div>
                
            </div>}
            <Searchbar />
            <Nav />
            
        </header>
    )
};


export default Header;